import React, { useEffect, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const WORD_RE = /([A-Za-zÀ-ÿñÑ]+)/g;
export const OLD_SPELLING_TRANSLATIONS = ['RV1569', 'RV1602'];

let glossaryPromise = null;
const loadGlossary = () => {
  if (!glossaryPromise) {
    glossaryPromise = fetch('/data/old-spanish-glossary.json').then((r) => r.json()).catch(() => ({}));
  }
  return glossaryPromise;
};

const OldWord = ({ word, modern, language }) => (
  <Popover>
    <PopoverTrigger asChild>
      <span
        className="cursor-pointer underline decoration-dotted decoration-stone-400 underline-offset-[3px] hover:bg-amber-100/70 dark:hover:bg-amber-900/30 rounded-sm transition-colors"
        data-testid={`old-word-${word.toLowerCase()}`}
        onClick={(e) => e.stopPropagation()}
      >
        {word}
      </span>
    </PopoverTrigger>
    <PopoverContent className="w-auto max-w-[16rem] px-3 py-2" data-testid="old-word-popover">
      <p className="text-[10px] uppercase tracking-wider text-muted-foreground">{language === 'es' ? 'Español moderno' : 'Modern Spanish'}</p>
      <p className="text-sm"><span className="italic text-muted-foreground">{word}</span> → <span className="font-semibold">{modern}</span></p>
    </PopoverContent>
  </Popover>
);

// Verse text for the 1569/1602 Bibles: archaic words get a dotted underline; tap shows the modern form.
const OldSpanishText = ({ text, language }) => {
  const [glossary, setGlossary] = useState(null);
  useEffect(() => {
    let alive = true;
    loadGlossary().then((g) => { if (alive) setGlossary(g); });
    return () => { alive = false; };
  }, []);

  if (!glossary) return <>{text}</>;
  const parts = [];
  let last = 0;
  let m;
  WORD_RE.lastIndex = 0;
  while ((m = WORD_RE.exec(text)) !== null) {
    const modern = glossary[m[1].toLowerCase()];
    if (!modern) continue;
    if (m.index > last) parts.push(text.slice(last, m.index));
    parts.push(<OldWord key={m.index} word={m[1]} modern={modern} language={language} />);
    last = m.index + m[1].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <span data-testid="old-spanish-text">{parts}</span>;
};

export default OldSpanishText;
